import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const billingPaymentTrackStyle = (theme) => ({
	tabsButtons: {
		display: 'flex',
		flexDirection: 'row-reverse',
		marginTop: 24,
		'& > :first-child': {
			margin: '0 0 0 8px',
		},
	},
	tabsButtonsIn: {
		backgroundColor: whiteColor,
		marginTop: 0,
		paddingRight: '32px',
		paddingBottom: '32px',
		width: '70%',
		maxWidth: '624px',
		margin: '0 auto',
		borderBottomLeftRadius: '8px',
		borderBottomRightRadius: '8px',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	headingWrapper: {
		padding: '24px 32px 32px 24px',
	},
	smallTab: {
		width: '70%',
		maxWidth: '624px',
		margin: '0 auto',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	right: {
		textAlign: 'right',
	},
	nextButton: {
		width: 120,
	},
	confirmPaymentButton: {
		width: 168,
	},
	tab: {
		marginTop: '24px',
		padding: '24px',
		minHeight: '640px',
		backgroundColor: whiteColor,
		borderRadius: '8px 8px 0 0',
	},
	uploadProofWrapper: {
		padding: '50px',
		[theme.breakpoints.down('xs')]: {
			padding: 0,
		},
	},
	allowedFormats: {
		margin: '8px 0 8px 0',
	},
	uploadProofFiles: {
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
	},
	errorBox: {
		marginTop: '10px',
	},
	fileUploadHeader: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		marginBottom: '14px !important',
		marginTop: '28px',
	},
	downloadLink: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			position: 'relative',
			bottom: '2px',
			marginRight: '4px',
		},
	},
	bannerWrapper: {
		margin: '24px auto',
	},
});

export default billingPaymentTrackStyle;
